import CustomButton from "@/views/customButton.vue";
import { mapGetters } from "vuex";
import { transactionSourceEnum } from "@/store/modules/user/enums";
import {
  CURRENCY_COMPARE,
  GET_EXTERNAL_STATUS,
  GET_EXTERNAL_STATUS_EVENT,
  GET_PAYABLE_AMOUNT,
  PURCHASE_EXTERNAL,
  SET_RESULT_PAGE_DATA,
  SET_TAB,
  USER_TRACK_EVENTS,
  WALLET_PAYMENT_CONFIRMED,
  EXTERNAL_STATUS_TIMER,
} from "@/store/modules/user/consts";

import VerticalProgressBar from "../VerticalProgressBar.vue";
import PopupModal from "@/components/PopupModal.vue";
import { PARTIAL_PAYMENT_TRIGGER } from "@/utils/event.constants";
import config from "@/utils/config";
import { iframeClient, paymentSteps } from "@/utils/config";
import { isMobileAgent } from "@/utils/helper";
import {
  useBalance,
  useDisconnect,
  useSendTransaction,
  useWriteContract,
} from "@wagmi/vue";
import {
  useAppKit,
  useAppKitAccount,
  useAppKitBalance,
  useAppKitEvents,
  useAppKitNetwork,
  useWalletInfo,
} from "@reown/appkit/vue";
import { erc20Abi, parseEther, parseUnits } from "viem";
import { BITCOIN_NETWORK } from "@/utils/stringconsts";
import WalletConnectInfoModal from "./WalletConnectInfoModal.vue";
import { computed, getCurrentInstance, watch } from "vue";
import { concordiumAdapter } from "@/utils/wagmi.config";
import { ConstantsUtil as CommonConstantsUtil } from "@reown/appkit-common";
import {
  CCD_NAMESPACE,
  CCD_CHAIN_ID,
} from "@/utils/concordium/ccdConstants.js";
import concordiumIcon from "@/assets/img/Concordium_black_symbol.png";
import rocketfuelIcon from "@/assets/img/rocketfuel-circular.svg";
import {
  getBalanceFromAlchemy,
  getBalanceFromConcordium,
} from "./nonevm-utils";
import { recoverStuckWalletConnectState } from "@/utils/concordium/walletConnectRecovery.js";
import {
  isEvmStyleAddress,
  isLikelyConcordiumAddress,
} from "@/utils/concordium/ccdSessionUtils.js";
export default {
  name: "WalletConnect",
  components: {
    CustomButton,
    VerticalProgressBar,
    PopupModal,
    WalletConnectInfoModal,
  },
  props: {
    cartData: Object,
  },
  setup() {
    const instance = getCurrentInstance();
    const { open } = useAppKit();
    const appKitAccount = useAppKitAccount();
    const appKitNetwork = useAppKitNetwork();
    const events = useAppKitEvents();
    const walletInfoState = useWalletInfo();

    const account = computed(() => {
      const isConnected =
        appKitAccount.value?.isConnected ||
        appKitAccount.value?.status === "connected";
      const address =
        appKitAccount.value?.address ||
        appKitAccount.value?.caipAddress?.split(":").pop() ||
        null;
      const activeNetwork = appKitNetwork.value;
      const onConcordium =
        activeNetwork?.caipNetworkId === `${CCD_NAMESPACE}:${CCD_CHAIN_ID}` ||
        activeNetwork?.chainNamespace === CCD_NAMESPACE;

      if (
        isConnected &&
        address &&
        address != "undefined" &&
        appKitAccount.value.status === "connected"
      ) {
        if (onConcordium) {
          const validCcdAddress =
            isLikelyConcordiumAddress(address) && !isEvmStyleAddress(address);
          if (!validCcdAddress) {
            return {
              isConnected: false,
              address: null,
              chainId: null,
            };
          }
        }
        return {
          isConnected: true,
          address,
        };
      }

      return {
        isConnected: false,
        address: null,
        chainId: null,
      };
    });

    const isConnected = computed(() => account.value.isConnected);
    const address = computed(() => account.value.address);
    const chainId = computed(() => {
      const network = appKitNetwork.value;
      if (network) {
        return network.id || network.chainId || null;
      }
      return null;
    });

    const network = computed(() => appKitNetwork.value);

    const walletInfo = computed(() => {
      const rawInfo =
        walletInfoState.walletInfo?.value ?? walletInfoState.walletInfo;
      const embedded =
        walletInfoState.embeddedWalletInfo?.value ??
        walletInfoState.embeddedWalletInfo;

      if (rawInfo) {
        const info = { ...rawInfo };
        if (info.name?.toLowerCase().includes("concordium")) {
          info.icon = concordiumIcon;
        }
        return info;
      }

      if (embedded) {
        return embedded;
      }

      return {
        name: "WalletConnect",
        id: "walletConnect",
        image_id: "walletConnect",
        icon: rocketfuelIcon,
        image_url: rocketfuelIcon,
      };
    });

    watch(
      events,
      (val) => {
        if (val?.data?.event === "MODAL_CLOSE" && !isConnected.value) {
          instance?.emit("walletConnected", false);
        }
      },
      { deep: true, immediate: true }
    );

    const { fetchBalance } = useAppKitBalance();
    const { disconnect } = useDisconnect();
    const { refetch } = useBalance({
      address,
    });
    const { sendTransaction } = useSendTransaction();
    const { writeContract } = useWriteContract();

    return {
      chainId,
      isConnected,
      address,
      open,
      fetchBalance,
      sendTransaction,
      refetch,
      disconnect,
      paymentSteps,
      writeContract,
      network,
      walletInfo,
    };
  },
  mounted() {
    this.$nextTick(async () => {
      await recoverStuckWalletConnectState();

      const onConcordium =
        this.network?.caipNetworkId === `${CCD_NAMESPACE}:${CCD_CHAIN_ID}` ||
        this.network?.chainNamespace === CCD_NAMESPACE;
      if (onConcordium && this.address && isEvmStyleAddress(this.address)) {
        await this.handleUnsupportedConcordiumSwitch();
        return;
      }

      this.syncWalletConnectedToParent();
      if (this.showsConnectedPayment) {
        this.getBalance();
      }
    });
  },
  data() {
    return {
      tokens: [],
      selectedToken: null,
      payableData: null,
      qrData: {},
      inProgressWallet: null,
      customErrorMessage: "",
      balanceError: false,
      balanceErrorMessage: "",
      hash: "",
      convertedCart: {},
      transactionStatus: 0,
      paymentStatus: null,
      count: 0,
      curCntValue: 0,
      interval: null,
      time: null,
      showDropdown: false,
      walletConnect: "walletConnect",
      disconnectModal: false,
      resultData2: {
        // eslint-disable-next-line
        icon: require("@/assets/img/success.svg"),
        title: this.$t("result.success"),
        description: this.$t("result.success-text"),
      },
      loaderTitle: "",
      loaderIcon: "",
      loaderDescription: "",
      loaderButtonText: "Cancel",
      disableDropDown: false,
      infoModal: false,
      stopPaymentCheck: false,
      externalCallPromise: null,
      lastExternalTokenSymbol: null,
      walletPaymentSuspended: false,
    };
  },
  unmounted() {
    this.clearThisInterval();
  },
  watch: {
    selectedToken: {
      async handler(val) {
        if (val?.symbol) {
          await this.prepareExternalPayment();
        }
      },
      deep: true,
    },
    qrData: {
      async handler(qr) {
        if (qr?.walletPayment) {
          if (this.hash) {
            this.transactionStatus = 1;
            this.initiateSSE(0);
          }
        }
      },
      deep: true,
    },
    isConnected: {
      handler(val) {
        if (!val) {
          this.walletPaymentSuspended = false;
        }
        this.syncWalletConnectedToParent();
        if (val && !this.walletPaymentSuspended) {
          this.getBalance();
          this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
            moduleInfo: {
              current: "SuccessWalletConnect",
              activity: "Shopper successfully connects wallet",
              meta: {
                walletConnect: this.walletInfo?.name,
                client: isMobileAgent()
                  ? iframeClient.mobile
                  : iframeClient.desktop,
              },
            },
          });
        }
      },
      immediate: true,
    },
    network: {
      async handler(network) {
        const onConcordium =
          network?.caipNetworkId === `${CCD_NAMESPACE}:${CCD_CHAIN_ID}` ||
          network?.chainNamespace === CCD_NAMESPACE;

        const incompatibleConcordium =
          onConcordium && this.address && isEvmStyleAddress(this.address);

        if (incompatibleConcordium) {
          await this.handleUnsupportedConcordiumSwitch();
          return;
        }

        if (onConcordium && !this.isConnected) {
          await recoverStuckWalletConnectState();
          this.syncWalletConnectedToParent();
          return;
        }

        this.syncWalletConnectedToParent();

        if (this.showsConnectedPayment) {
          this.getBalance();
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      currencies: "user/currencies",
      settings: "user/settings",
      displayCurrency: "user/displayCurrency",
      cart: "user/cart",
      userInfo: "user/userInfo",
      paymentCompleted: "auth/paymentCompleted",
      order: "auth/getOrderData",
    }),
    amount() {
      if (this.cart && this.selectedToken) {
        return this.cart.amount * this.selectedToken.currentRate;
      }
      return 0;
    },
    isPayableDataLoaded() {
      return (
        this.payableData &&
        typeof this.payableData.payable_amount !== "undefined" &&
        this.payableData.payable_amount !== null &&
        typeof this.payableData.conversion_rate_per_unit !== "undefined" &&
        this.payableData.conversion_rate_per_unit !== null
      );
    },
    assetSymbol() {
      const symbol =
        this.selectedToken?.symbol || this.payableData?.payable_currency;
      return symbol ? String(symbol).toUpperCase() : "";
    },
    displayCurrencyCode() {
      const code =
        this.displayCurrency?.code ||
        this.displayCurrency?.currency ||
        this.displayCurrency?.id ||
        this.payableData?.order_currency ||
        "";
      return code ? String(code).toUpperCase() : "";
    },
    exchangeRateLabel() {
      let rate = Number(this.payableData?.conversion_rate_per_unit);
      const base = this.assetSymbol;
      const target = this.displayCurrencyCode;
      if (target && target.toLowerCase() !== "usd") {
        rate =
          Number(this.payableData?.conversion_rate_per_unit) /
          Number(this.displayCurrency?.currentRate || 1);
      }
      if (!base || !target || !Number.isFinite(rate) || rate <= 0) {
        return "";
      }
      const formattedRate = this.formatExchangeRate(rate);
      return formattedRate ? `1 ${base} ≈ ${formattedRate} ${target}` : "";
    },
    isConcordium() {
      return this.network?.caipNetworkId === `${CCD_NAMESPACE}:${CCD_CHAIN_ID}`;
    },
    showsConnectedPayment() {
      return this.isConnected && !this.walletPaymentSuspended;
    },
  },
  methods: {
    syncWalletConnectedToParent() {
      this.$emit("walletConnected", this.showsConnectedPayment);
    },
    clearWalletPaymentState() {
      this.tokens = [];
      this.selectedToken = null;
      this.payableData = null;
      this.qrData = {};
      this.customErrorMessage = "";
      this.balanceError = false;
      this.balanceErrorMessage = "";
      this.lastExternalTokenSymbol = null;
    },
    async handleUnsupportedConcordiumSwitch() {
      this.walletPaymentSuspended = true;
      this.clearWalletPaymentState();
      this.syncWalletConnectedToParent();

      await recoverStuckWalletConnectState();

      try {
        await this.disconnect();
      } catch (error) {
        console.warn(
          "[WalletConnect] Error disconnecting after unsupported Concordium switch:",
          error
        );
      }

      try {
        const walletConnectConnectorId =
          CommonConstantsUtil.CONNECTOR_ID.WALLET_CONNECT;
        await concordiumAdapter.disconnect({
          id: walletConnectConnectorId,
          fullTeardown: false,
        });
      } catch (error) {
        console.warn(
          "[WalletConnect] Error resetting Concordium adapter:",
          error
        );
      }

      this.walletPaymentSuspended = false;
      this.syncWalletConnectedToParent();
    },
    getLiveIcon(walletInfo) {
      return (
        walletInfo?.icon ||
        walletInfo?.image_url ||
        require("@/assets/img/wallets/walletConnect.svg")
      );
    },
    onImgError(event) {
      event.target.onerror = null; // prevent infinite loop
      event.target.src = require("@/assets/img/wallets/walletConnect.svg");
    },
    formatExchangeRate(value) {
      if (value === undefined || value === null || value === "") {
        return "";
      }
      try {
        const decimalValue = this.DecimalNumber(value);
        return decimalValue.toFixed(2);
      } catch (error) {
        console.error("Failed to format exchange rate:", error);
        return String(value);
      }
    },
    async handleShowInfoModal(flag) {
      this.infoModal = flag;
    },
    handleShowChange(val) {
      this.infoModal = val;
    },
    handleSelectToken(val) {
      if (val.currentRate) {
        this.selectedToken = val;
        this.showDropdown = false;
      }
    },
    async getMainBalance() {
      const nativeBalanceRes = await this.fetchBalance();
      console.log("🚀 ~ nativeBalanceRes:", nativeBalanceRes);
      let mainBalance = null;
      if (nativeBalanceRes?.isSuccess) {
        const data = nativeBalanceRes.data;
        if (data && Array.isArray(data)) {
          const t = data.map((item) => {
            const currentCurrency = this.currencies.find(
              (c) => c.id === item.symbol
            );
            if (currentCurrency) {
              return {
                symbol: item.symbol,
                tokenBalance: item.balance,
                logo: currentCurrency.logo,
                currentRate: currentCurrency.currentRate,
                isStableCoin: currentCurrency.isStableCoin,
                usdBalance: this.DecimalNumber(item.balance)
                  .mul(currentCurrency.currentRate)
                  .toFixed(2),
                chainNetwork:
                  currentCurrency["chains.network"] ||
                  currentCurrency.chainNetwork,
              };
            } else {
              return null;
            }
          });
          mainBalance = t;
        } else {
          const currentCurrency = this.currencies.find(
            (c) => c.id === data.symbol
          );
          if (currentCurrency) {
            mainBalance = {
              symbol: data.symbol,
              tokenBalance: data.balance,
              logo: currentCurrency.logo,
              currentRate: currentCurrency.currentRate,
              isStableCoin: currentCurrency.isStableCoin,
              usdBalance: this.DecimalNumber(data.balance)
                .mul(currentCurrency.currentRate)
                .toFixed(2),
              chainNetwork:
                currentCurrency["chains.network"] ||
                currentCurrency.chainNetwork,
            };
          } else {
            return null;
          }
        }
      }
      // filter out the null values
      if (Array.isArray(mainBalance)) {
        mainBalance = mainBalance.filter((item) => item !== null);
      }
      return mainBalance;
    },
    async getBalance(val) {
      try {
        // Don't fetch balance if chainId is not available or currencies are not loaded
        if (!this.address || !this.chainId || !this.currencies?.length) {
          console.warn(
            "⚠️ [WalletConnect] getBalance - chainId or currencies not available, waiting..."
          );
          setTimeout(() => {
            this.getBalance();
          }, 2000);
          return;
        }
        this.loaderTitle = this.$t("walletconnect.connecting");
        this.loaderDescription = "";
        this.loaderButtonText = "";
        this.$refs.boxLoader.start();
        this.tokens = [];
        this.customErrorMessage = "";
        this.balanceError = false;
        this.balanceErrorMessage = "";
        // 1. Fetch native balance
        const mainBalance = await this.getMainBalance();
        console.log("🚀 ~ mainBalance:", mainBalance, this.isConcordium);
        // 2. Fetch token balances dynamically from Alchemy
        if (this.isConcordium) {
          this.tokens = await getBalanceFromConcordium(
            this.address,
            this.chainId,
            this.currencies,
            mainBalance
          );
        } else {
          this.tokens = await getBalanceFromAlchemy(
            this.address,
            this.chainId,
            this.currencies,
            mainBalance
          );
        }
        if (this.tokens.length > 0) {
          this.selectedToken = this.tokens[0];
        } else {
          this.balanceError = true;
          this.balanceErrorMessage =
            this.$t("walletconnect.balanceCannotBeListed") ||
            "Your balance cannot be listed. Please try again later.";
          this.customErrorMessage =
            "There are no tokens in your wallet. Please add tokens and try again.";
          this.tokens = [];
          this.selectedToken = null;
          this.balanceError = true;
        }
        this.$refs.boxLoader.hide();
      } catch (err) {
        console.error("getBalance error", err);
        this.balanceError = true;
        this.balanceErrorMessage =
          this.$t("walletconnect.balanceCannotBeListed") ||
          "Your balance cannot be listed. Please try again later.";
        this.tokens = [];
        this.selectedToken = null;
        if (!val) this.getBalance(1);
        this.customErrorMessage = err?.message || "Failed to fetch balances";
        this.$refs.boxLoader.hide();
      }
    },

    async prepareExternalPayment() {
      const tokenSymbol = this.selectedToken?.symbol;
      if (!tokenSymbol) {
        return false;
      }

      if (this.qrData?.id && this.lastExternalTokenSymbol === tokenSymbol) {
        return true;
      }

      if (this.externalCallPromise) {
        try {
          return await this.externalCallPromise;
        } catch (err) {
          console.error("prepareExternalPayment error", err);
          return false;
        }
      }

      const promise = (async () => {
        const previousId = this.qrData?.id;
        try {
          const response = await this.callExternalPurchase();
          if (this.selectedToken?.symbol !== tokenSymbol) {
            return false;
          }
          if (!response?.id) {
            this.lastExternalTokenSymbol = null;
            return false;
          }
          this.qrData = response;
          await this.getPayableData(response.id);
          this.lastExternalTokenSymbol = tokenSymbol;
          if (response.id !== previousId) {
            this.stopPaymentCheck = false;
            this.count = 0;
            this.initiateSSE(0);
          }
          return true;
        } catch (err) {
          console.error("prepareExternalPayment error", err);
          return false;
        } finally {
          this.externalCallPromise = null;
        }
      })();

      this.externalCallPromise = promise;
      return await promise;
    },

    async handlePay() {
      // create transaction
      this.loaderTitle = this.$t("walletconnect.loader.waiting");
      this.loaderDescription = this.$t("walletconnect.loader.check-wallet");
      this.loaderButtonText = this.$t("walletconnect.loader.cancel");
      this.$refs.boxLoader.start();
      try {
        this.customErrorMessage = "";
        const prepared = await this.prepareExternalPayment();
        if (
          !prepared ||
          !this.qrData?.amount ||
          !this.payableData?.payable_amount
        ) {
          this.$refs.boxLoader.hide();
          this.customErrorMessage = "cannot proceed with payment";
          return;
        }
        let amount = this.payableData.payable_amount;
        let value = parseEther(amount.toString()).toString();
        if (this.network?.caipNetworkId.includes(BITCOIN_NETWORK)) {
          value = Number(amount);
        }
        // For Concordium, value should be in CCD (not micro CCD)
        // The adapter will convert it to micro CCD internally
        if (this.isConcordium) {
          value = Number(amount);
        }
        const request = {
          to: this.qrData.meta.receiverAddress,
          value,
          account: this.address,
          data: "0x0",
        };
        // common success and failure callback
        const callback = {
          onSuccess: async (hash) => {
            await this.$store.dispatch(`user/${WALLET_PAYMENT_CONFIRMED}`, {
              encrypted: this.Encrypt({
                clientId: this.convertedCart.merchant_id,
                id: this.qrData.id,
                offerId: this.convertedCart.order,
                hash,
                walletname: this.walletInfo?.name || "WalletConnect",
              }),
              source: transactionSourceEnum.IFRAME_WALLET_CONNECT,
            });
            this.hash = hash;
            this.transactionStatus = 1;
            this.initiateSSE(0);
            this.$refs.boxLoader.hide();
          },
          onError: (err) => {
            this.$refs.boxLoader.hide();
            this.customErrorMessage = err.details;
            this.$refs?.boxLoader?.hide();
          },
        };
        // if the chain is a non-EVM chain, use the sendTransaction functionality
        if (this.isConcordium) {
          try {
            // For Concordium, use the adapter directly instead of wagmi
            // Import the adapter to use its sendTransaction method
            const { concordiumAdapter } = await import("@/utils/wagmi.config");

            // Send transaction using the Concordium adapter directly
            // This bypasses wagmi's address validation which expects hex addresses
            request.currency = this.selectedToken?.symbol;
            const result = await concordiumAdapter.sendTransaction(request);
            console.log("🚀 ~ result:", result);
            if (result.hash) {
              callback.onSuccess(result.hash);
            } else {
              callback.onError(new Error("Failed to send transaction"));
            }
            return;
          } catch (error) {
            callback.onError(error);
            return;
          }
        }
        // if the selected is a token
        if (this.selectedToken?.contractAddress) {
          // write a contract if its an EVM chain token
          await this.writeContract(
            {
              address: this.selectedToken?.contractAddress,
              abi: erc20Abi,
              functionName: "transfer",
              args: [request.to, parseUnits(amount?.toString(), 6)],
            },
            callback
          );
          return;
        } else {
          // if the token selected is the main chain currency use the send functionality
          this.sendTransaction(request, callback);
        }
      } catch (err) {
        this.customErrorMessage = err.details;
        this.$refs.boxLoader.hide();
      }
    },

    async getPayableData(txId) {
      if (!this.selectedToken.symbol || !this.cart.uuid) return;

      try {
        const resp = await this.$store.dispatch(`user/${GET_PAYABLE_AMOUNT}`, {
          cc: this.selectedToken.symbol,
          invoice: this.cart.uuid,
          txId: txId,
        });
        this.payableData = resp;
      } catch (err) {
        // todo: handle error
      }
    },

    async callExternalPurchase() {
      try {
        this.qrData = {};
        this.customErrorMessage = "";
        let conversionRate = 1;
        const usdEquivalentRate = 1;
        this.convertedCart = {};

        if (this.settings?.displayCurrency !== undefined && this.cart) {
          // eslint-disable-next-line no-param-reassign, vue/no-mutating-props
          this.cart.currency = this.cart?.currency || "USD";

          const cartCurrency = this.cart.currency.toUpperCase();
          const displayCurrency = this.settings.displayCurrency.toUpperCase();

          if (displayCurrency !== cartCurrency) {
            conversionRate = await this.getCurrConverRate(
              cartCurrency,
              displayCurrency
            );
          }

          this.convertedCart = this.cart;
          this.convertedCart.usdEquivalentRate = usdEquivalentRate;
          this.convertedCart.conversionRate = conversionRate;
          this.convertedCart.displayCurrency = this.settings?.isUserConfigured
            ? displayCurrency
            : cartCurrency;
        }

        if (
          !this.convertedCart ||
          !this.convertedCart.cart ||
          !this.convertedCart.amount
        ) {
          throw new Error("cart data invalid!");
        }

        // Ensure chainNetwork is set - get it from currency if missing
        if (!this.selectedToken.chainNetwork && this.selectedToken.symbol) {
          const currency = this.currencies.find(
            (c) => c.id === this.selectedToken.symbol
          );
          if (currency) {
            this.selectedToken.chainNetwork =
              currency["chains.network"] || currency.chainNetwork;
          }
        }

        if (!this.selectedToken.chainNetwork) {
          throw new Error("chainNetwork is required for payment");
        }

        const encryptedData = this.Encrypt({
          clientId: this.convertedCart.merchant_id,
          amount: this.convertedCart.amount,
          currency: this.selectedToken.symbol.toUpperCase(),
          chainNetwork: this.selectedToken.chainNetwork,
          cart: this.convertedCart.cart,
          shippingAddress: this.cart.shippingAddress || null,
          merchantStoreCurrency: this.cart.currency,
          offerId: this.convertedCart.order,
          confirmation: this.convertedCart.encrypted || "",
          hostedPageId: this.convertedCart.uuid || "",
        });

        const res = await this.$store.dispatch(`user/${PURCHASE_EXTERNAL}`, {
          encrypted: encryptedData,
          source: transactionSourceEnum.WALLET,
        });

        if (res.status === "ok") {
          if (
            Number(this.selectedToken?.tokenBalance) <=
            Number(res.response.amount)
          ) {
            this.customErrorMessage = "Low Wallet Balance";
          }
          return res.response;
        }

        if (res.status === "error") {
          this.customErrorMessage = res.response;
          return null;
        }
      } catch (e) {
        this.customErrorMessage = e?.message;
        return null;
      }
    },

    async getCurrConverRate(from, to) {
      const res = await this.$store.dispatch(`user/${CURRENCY_COMPARE}`, {
        to: to.toUpperCase(),
        from: from.toUpperCase(),
        source: transactionSourceEnum.WALLET,
      });
      if (res.status === "ok") {
        return res[to.toUpperCase()];
      }
      return 1;
    },
    async initiateSSE(isReOpen) {
      try {
        const payload = {
          txId: this.qrData.id,
          source: transactionSourceEnum.WALLET,
          jobTrack: true,
        };
        const resp = await this.$store.dispatch(
          `user/${GET_EXTERNAL_STATUS}`,
          payload
        );
        if (!resp?.data?.result?.success) {
          this.retrySSE();
        } else {
          if (isReOpen) {
            this.validatePayment();
          } else {
            this.addTimeoutPaymentCheck();
          }
        }
        return;
      } catch (err) {
        console.log(err);
        this.retrySSE();
      }
    },
    async retrySSE() {
      setTimeout(() => {
        this.initiateSSE(0);
      }, 5000);
    },
    async validatePayment() {
      if (!this.qrData?.id) return;
      this.count += 1;
      try {
        const encrypt = Buffer.from(
          this.Encrypt({ txId: this.qrData.id })
        ).toString("base64");
        const resp = await this.$store.dispatch(
          `user/${GET_EXTERNAL_STATUS_EVENT}`,
          { encrypt }
        );

        if (resp?.data?.result?.responseObj) {
          this.paymentStatus = resp?.data?.result?.responseObj;
        }
        this.validateResponse(resp?.data?.result?.responseObj, true);
        return;
      } catch (err) {
        console.log(err);
        this.addTimeoutPaymentCheck();
      }
    },
    addTimeoutPaymentCheck() {
      const that = this;
      if (this.stopPaymentCheck) {
        return;
      }
      this.time = setTimeout(() => {
        if (that.count <= 300) {
          that.validatePayment();
        } else {
          clearTimeout(this.time);
        }
      }, this.getTrackingInterval());
    },
    getTrackingInterval() {
      // Use 10 seconds interval for wallet connect SSE calls
      return 10000;
    },
    clearThisInterval() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      if (this.time) {
        clearTimeout(this.time);
      }
    },
    async validateResponse(data, isvalidate) {
      if (!data || !data?.txStatus) {
        if (isvalidate) {
          this.addTimeoutPaymentCheck();
        }
        return;
      }
      this.paymentStatus = data;
      switch (data.txStatus) {
        case "pending": {
          if (isvalidate) {
            this.addTimeoutPaymentCheck();
          }
          break;
        }
        case "partial": {
          this.$refs.boxLoader.hide();
          window.EventBus.emit(PARTIAL_PAYMENT_TRIGGER);
          if (isvalidate) {
            this.addTimeoutPaymentCheck();
          }
          break;
        }
        case "completed": {
          this.clearThisInterval();
          this.$store.commit("user/setFsStatus", data?.fsStatus);
          await this.$store.commit("auth/changePaymentCompleted");
          this.paymentStatus = data;
          this.transactionStatus = 2;
          setTimeout(() => {
            this.complete(this.paymentStatus);
          }, 2000);
          break;
        }
        case "complianceBlocked": {
          this.clearThisInterval();
          await this.$store.commit("auth/changePaymentCompleted");
          setTimeout(() => {
            this.complianceBlocked(this.paymentStatus);
          }, 2000);
          break;
        }
        default:
          this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
            moduleInfo: {
              current: "IncompletePayment",
              activity: "Payment using WalletConnet fails or shopper cancels",
              meta: {
                walletConnect: this.walletInfo?.name,
                status: "Failed",
              },
            },
          });
          break;
      }
    },
    async complete(paymentStatus) {
      try {
        this.customErrorMessage = "";
        this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
          moduleInfo: {
            current: "Wallet Connect",
            activity: "Wallet Connect Payment Success",
            meta: {
              name: this.selectedToken?.symbol,
              walletConnect: this.walletInfo?.name,
            },
          },
        });
        await this.$store.commit("user/clearCart");
        this.notifyPaymentResultToParent({
          type: "rocketfuel_result_ok",
          response: {
            paymentMode: "Wallet",
            status: paymentStatus.txStatus,
            recievedAmount: paymentStatus.recievedAmount,
            currency: paymentStatus.currency,
            offerId: this.order?.order,
          },
          paymentCompleted: this.paymentCompleted,
        });
        this.$store.dispatch(`user/${SET_TAB}`, "");
      } catch (err) {
        console.log("complete", err);
      } finally {
        this.lastExternalTokenSymbol = null;
        this.resultData2.paymentData = paymentStatus;
        this.$store.dispatch(`user/${SET_RESULT_PAGE_DATA}`, this.resultData2);
        if (this.userInfo && this.userInfo.ssoStatus) {
          this.$router.push({ name: "Thank" });
        } else {
          this.$router.push({
            name: "Result",
          });
        }
      }
    },
    async complianceBlocked(paymentStatus) {
      try {
        this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
          moduleInfo: {
            current: "Wallet Connect",
            activity: "Wallet Connect Payment Compliance Blocked",
            meta: {
              name: this.selectedToken?.symbol,
              walletConnect: this.walletInfo?.name,
            },
          },
        });
        await this.$store.commit("user/clearCart");
        this.notifyPaymentResultToParent({
          type: "rocketfuel_result_ok",
          response: {
            paymentMode: "Wallet",
            status: paymentStatus.txStatus,
            recievedAmount: paymentStatus.recievedAmount,
            currency: paymentStatus.currency,
            offerId: this.order?.order,
          },
          paymentCompleted: this.paymentCompleted,
        });
        this.$store.dispatch(`user/${SET_TAB}`, "");
      } catch (err) {
        console.log("complianceBlocked", err);
      } finally {
        this.lastExternalTokenSymbol = null;
        this.resultData2.paymentData = paymentStatus;
        this.$store.dispatch(`user/${SET_RESULT_PAGE_DATA}`, this.resultData2);
        this.$router.push({ name: "Compliance Blocked" });
      }
    },
    handleCancel() {
      this.handleDisconnectModal(false);
    },
    async handleDisconnect() {
      this.loaderTitle = this.$t("Disconnecting...");
      this.loaderDescription = "";
      this.loaderButtonText = "";
      this.$refs.boxLoader.start();
      try {
        // Always disconnect both adapters to ensure clean state
        // This prevents network state from persisting when switching between EVM and non-EVM chains

        // Disconnect Wagmi adapter (for EVM chains)
        try {
          await this.disconnect();
        } catch (error) {
          console.warn(
            "⚠️ [WalletConnect] Error disconnecting Wagmi adapter:",
            error
          );
        }

        // Disconnect Concordium adapter (for non-EVM chains)
        try {
          const walletConnectConnectorId =
            CommonConstantsUtil.CONNECTOR_ID.WALLET_CONNECT;
          await concordiumAdapter.disconnect({
            id: walletConnectConnectorId,
            fullTeardown: true,
          });
        } catch (error) {
          console.warn("Error disconnecting Concordium adapter:", error);
        }

        this.disconnectModal = false;
        this.tokens = [];
        this.selectedToken = null;
        this.payableData = null;
        this.qrData = {};
        this.customErrorMessage = "";
        this.handleDisconnectModal(false);
      } catch (error) {
        console.error("Error disconnecting:", error);
        this.handleDisconnectModal(false);
      }
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: "DisconnectWalletConnet",
          activity: "Shopper disconnects a connected wallet",
          meta: {
            walletConnect: this.walletInfo?.name,
          },
        },
      });
      const that = this;
      setTimeout(() => {
        that.$refs?.boxLoader?.hide();
      }, 2000);
      this.lastExternalTokenSymbol = null;
    },
    handleDisconnectModal(val) {
      // Handle both event object and boolean value
      const modalValue = typeof val === "boolean" ? val : true;
      this.disconnectModal = modalValue;
    },
    cancelPay() {
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: "IncompletePayment",
          activity: "Payment using WalletConnet fails or shopper cancels",
          meta: {
            walletConnect: this.walletInfo?.name,
            status: "Cancelled",
          },
        },
      });
      this.lastExternalTokenSymbol = null;
    },
    async openModal() {
      await recoverStuckWalletConnectState();
      this.$nextTick(() => {
        try {
          this.open({ view: "Connect" });
        } catch (err) {
          console.error("[WalletConnect] Failed to open Reown modal:", err);
        }
      });
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: "WALLETCONNECT_MODAL_OPENED",
          activity: "Payment using WalletConnet Modal opened",
          meta: {
            walletConnect: this.walletInfo?.name,
          },
        },
      });
    },
  },
};
